// ================================================================
// CORE.JS - Coordenador Principal do Módulo Operacional
// Gerencia navegação entre dashboard, prescrições, diário e calendário
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

// Adicionar propriedades ao objeto existente (não sobrescrever)
Object.assign(window.FazendaRP.Pages.operacional, {
    // ===== STATE =====
    activeTab: 'dashboard', // 'dashboard', 'prescricoes', 'diario', 'calendario'
    container: null,

    // ===== INITIALIZATION =====
    init: function (container) {
        this.container = container;
        this.render();
    },

    // ===== MAIN RENDER =====
    render: async function () {
        if (!this.container) return;

        // Main Navigation
        const navHtml = `
            <style>
                .nav-link { text-decoration: none; color: #6b7280; font-weight: 600; padding: 5px 0; border-bottom: 2px solid transparent; font-size: 0.95rem; transition: all 0.2s; }
                .nav-link:hover { color: #10b981; }
                .nav-link.active { color: #059669; border-bottom-color: #059669; }
            </style>
            <div style="display: flex; gap: 20px; border-bottom: 1px solid #e5e7eb; margin-bottom: 20px; padding-bottom: 10px;">
                <a href="#" class="nav-link ${this.activeTab === 'dashboard' ? 'active' : ''}" onclick="window.FazendaRP.Pages.operacional.switchTab('dashboard'); return false;">
                    <i class="fas fa-chart-pie"></i> Visão Geral
                </a>
                <a href="#" class="nav-link ${this.activeTab === 'prescricoes' ? 'active' : ''}" onclick="window.FazendaRP.Pages.operacional.switchTab('prescricoes'); return false;">
                    <i class="fas fa-clipboard-check"></i> Prescrições
                </a>
                <a href="#" class="nav-link ${this.activeTab === 'diario' ? 'active' : ''}" onclick="window.FazendaRP.Pages.operacional.switchTab('diario'); return false;">
                    <i class="fas fa-pen-to-square"></i> Diário de Campo
                </a>
                <a href="#" class="nav-link ${this.activeTab === 'calendario' ? 'active' : ''}" onclick="window.FazendaRP.Pages.operacional.switchTab('calendario'); return false;">
                    <i class="fas fa-calendar-days"></i> Calendário
                </a>
            </div>
            <div id="operacional-tab-container"></div>
        `;

        this.container.innerHTML = navHtml;

        // Load active tab
        this.switchTab(this.activeTab);
    },

    // ===== TAB NAVIGATION =====
    switchTab: function (tab) {
        this.activeTab = tab;
        const tabContainer = document.getElementById('operacional-tab-container');
        if (!tabContainer) {
            console.error('Tab container not found');
            return;
        }

        // Update nav links
        document.querySelectorAll('.nav-link').forEach(link => link.classList.remove('active'));
        event?.target?.classList.add('active');

        // Render appropriate tab content
        switch (tab) {
            case 'dashboard':
                if (window.FazendaRP.Pages.operacional.dashboard) {
                    window.FazendaRP.Pages.operacional.dashboard.render(tabContainer);
                } else {
                    tabContainer.innerHTML = '<div style="padding:40px; text-align:center; color:#9ca3af;">Dashboard módulo não carregado</div>';
                }
                break;

            case 'prescricoes':
                if (window.FazendaRP.Pages.operacional.prescricoes) {
                    window.FazendaRP.Pages.operacional.prescricoes.render(tabContainer);
                } else {
                    tabContainer.innerHTML = '<div style="padding:40px; text-align:center; color:#9ca3af;">Prescrições módulo não carregado</div>';
                }
                break;

            case 'diario':
                if (window.FazendaRP.Pages.operacional.diario) {
                    window.FazendaRP.Pages.operacional.diario.render(tabContainer);
                } else {
                    tabContainer.innerHTML = '<div style="padding:40px; text-align:center; color:#9ca3af;">Diário módulo não carregado</div>';
                }
                break;

            case 'calendario':
                if (window.FazendaRP.Pages.operacional.calendario) {
                    window.FazendaRP.Pages.operacional.calendario.render(tabContainer);
                } else {
                    tabContainer.innerHTML = '<div style="padding:40px; text-align:center; color:#9ca3af;">Calendário módulo não carregado</div>';
                }
                break;

            default:
                tabContainer.innerHTML = '<div style="padding:40px; text-align:center; color:#9ca3af;">Módulo em desenvolvimento</div>';
        }
    }
});
